import React from "react";
import customToast from "./../../components/common/basic/Toast";
import { dashboardColors, theme } from "./../../themes/Theme";

const ShareCopyCode = ({ code = "", className = "", style = {} }) => {
    const handleCopy = () => {
        if (!code) return;
        navigator.clipboard.writeText(code);
        customToast.success("The Code has been copied");
    };

    return (
        <div className="my-4">
            <h6>Copy Code</h6>
            <div
                className={`input url-input w-100 d-flex justify-content-between align-items-center ${className}`}
                style={style}
            >
                <span className="url-text">{code}</span>
                <span className="ml-4" onClick={handleCopy}>
                    <i
                        className="fas fa-copy"
                        style={{ color: dashboardColors[theme].primary, cursor: "pointer" }}
                    />
                </span>
            </div>

            <style jsx>{`
                .url-input {
                    background: #ecf2ff;
                    border: none;
                    padding: 0.5rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .url-text {
                    display: inline-block;
                    max-width: 90%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: ${dashboardColors[theme].primaryTextColor};
                }

                .url-input:hover {
                    background: #e4ebff;
                }

                .ml-4 {
                    margin-left: 1rem;
                }
            `}</style>
        </div>
    );
};

export default ShareCopyCode;